module.exports = __webpack_public_path__ + "img/btn4.e645b293.png";